// extracted by mini-css-extract-plugin
export var image = "_iq-0";